import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import Directories from "../components/Home/Directories";
import FormHome from "../components/Home/FormHome";
import Map from "../components/Contact/MapContent";
import BaseLayout from "../components/global/BaseLayout";
import CounterUp from "../components/global/CounterUp";
import ServicesHome from "../components/Services/ServicesHome_3";
import HeroVideo from "../components/Home/HeroVideo";
import Paletacolor from "../components/global/Paletacolor";
import BlockPrincipal from "../components/block/Block_swiper";
import BlockSecondary from "../components/block/Block_7";
import BlockAbout from "../components/block/Block_4";

import VideoPromocional from "../components/global/VideoPromocional";
import ContentServices from "../components/Services/ContentServices";
import GalleryContent from "../components/Gallery/GalleryContent";
// import Modal from "../components/Home/Modal";
// import CustomReviews from "../components/reviews/CustomReviews";

// para agregar la frase de los años de experiencia o la licencia agregar sloganPrincipal={true}
// para agregar la lista de about agregar listsAbout={true}
// para agregar la lista de servicios agregar listsServices={true}

function Home() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Home">
      <div className="md:max-w-full w-full">
        <input className="absolute -z-50" autoFocus></input>
        {/* <Modal /> */}
        <HeroVideo
          title={rpdata?.dbSlogan?.[6]?.slogan}
          texts={rpdata?.dbValues?.[0].description}
          urlVideo={
            "/videos/Painting Services.mp4"
          }
          bgImg={rpdata?.stock?.[0]}
          bgImg1={rpdata?.stock?.[1]}
          bgImg2={rpdata?.stock?.[2]}
          bgImg3={rpdata?.stock?.[6]}
        />
        <BlockPrincipal
          title={rpdata?.dbSlogan?.[1]?.slogan}
          text={rpdata?.dbHome?.[0].text}
          image={rpdata?.stock?.[10]}
          image1={rpdata?.stock?.[4]}
          image2={rpdata?.stock?.[6]}
          image3={rpdata?.stock?.[7]}
          image4={rpdata?.stock?.[9]}
          sloganPrincipal={true}
          listServices={true}
          corte={rpdata?.stock}
        />

        <div className="md:w-1/2 w-full flex md:flex-row mx-auto flex-col justify-center  items-center ">
          <img
            src="/img/satisfaction-guaranted.png"
            alt="Not found"
            width={"250px"}
            className="md:ml-14"
          />
          <img
              src="/img/20.png"
            alt="Not found"
            className="object-cover md:w-[230px] md:ml-0 ml-10"
          />
        </div>

        <Directories />

        {/* video promocional */}
        {rpdata?.videosPromo?.[0]?.activo ? (
          <VideoPromocional
            title={rpdata?.dbSlogan?.[2]?.slogan}
            text={rpdata?.dbAbout?.[1]?.text}
            linkVideo={`${rpdata?.videosPromo?.[0].link}`}
            image={`${rpdata?.videosPromo?.[0].img}`}
            vimeoVideo
          />
        ) : null}

        <BlockSecondary
          title={rpdata?.dbSlogan?.[3]?.slogan}
          text={rpdata?.dbHome?.[1]?.text}
          image1={rpdata?.stock?.[10]}
          image2={rpdata?.stock?.[3]}
          image3={rpdata?.stock?.[9]}
          image4={rpdata?.stock?.[8]}
        />

        <CounterUp image={rpdata?.stock?.[16]} />
        <BlockAbout
          title={"a little about us"}
          text={rpdata?.dbAbout?.[0]?.text}
          image2={rpdata?.stock?.[6]}
          image1={rpdata?.stock?.[2]}
          image3={rpdata?.stock?.[5]}
          listsAbout={true}
        />

        {/* our reviews */}
        {rpdata?.reviews?.isHomeOnly === true ? (
          <div className="w-4/5 mx-auto py-[100px]">
            <h1 className="pb-10 text-center">
              {rpdata?.labels?.general?.titleReviews}
            </h1>
            <div className={`${rpdata?.reviews?.links?.[0]}`}></div>
          </div>
        ) : null}
        {/* <CustomReviews/> */}
        {/* stock cuando es OnePages */}
        {/* Servicios del home */}
        {rpdata?.simpleWidgets?.[3]?.activo ? (
          <div className="pt-20">
            <ContentServices />
          </div>
        ) : (
          <ServicesHome />
        )}
        {/* Paleta de Colores */}
        {rpdata?.simpleWidgets?.[3]?.activo ? (
          <div className="pt-10 pb-28">
            <h2 className="text-center pb-[50px]">
              {rpdata?.labels?.general?.titleGallery}
            </h2>
            <GalleryContent
              galleryImages={
                rpdata?.stock?.length > 0 ? rpdata?.stock : rpdata?.stock
              }
            />
          </div>
        ) : null}
        {rpdata?.brandingExtra?.[0]?.activo ? <Paletacolor /> : null}
        <div
          className="bgFormHome"
          style={{ backgroundImage: `url("${rpdata?.stock?.[8]}")` }}
        >
          <div className="relative">
            <FormHome />
          </div>
        </div>
        <Map />
      </div>
    </BaseLayout>
  );
}

export default Home;
